import log from "loglevel";

import type { SmartHubAuthInfo, SmartHubAuthProfile } from "./definitions";
import { api } from "./api";
import { getStoredData } from "./localStorage";


const SMARTHUB_ACCESS_TOKEN_ID = "authentication.loginResponse"

export const smartHubDataHandler = {
    getSmartHubAuthInfo() {
        return getStoredData<SmartHubAuthInfo>(SMARTHUB_ACCESS_TOKEN_ID)
    },
    async getRemoteSmarthubData() {
        log.debug("smartHubDataHandler: fetching profile")

        try {
            const authInfo = this.getSmartHubAuthInfo()
            if (!authInfo) {
                log.debug("smartHubDataHandler: auth info not found skipping remote fetch")
                return null
            }

            return await api.contactBackend<SmartHubAuthProfile>("/smart-hub-profile-info", authInfo);
        }
        catch (e) {
            log.error("smartHubDataHandler: error fetching profile", e)
            return null
        }
    }
}

